import React, { useEffect, useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isTokenValid, clearAuth } from '../../utils/auth'

const ProtectedRoute = () => {
  const [checking, setChecking] = useState(true)
  const [valid, setValid] = useState(false)

  useEffect(() => {
    setValid(isTokenValid())
    setChecking(false)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isTokenValid()) {
        clearAuth()
        window.location.href = '/login'
      }
    }, 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  if (checking) return null // ella loading spinner venumna inga podalam

  return valid ? <Outlet /> : <Navigate to="/login" replace />
}

export default ProtectedRoute